// Studyo Today Backend
// Package studyo.today.schools.v1
// Service definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/snapshot_details.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file studyo/today/schools/v1/resources/snapshot_details.proto.
 */
export const file_studyo_today_schools_v1_resources_snapshot_details = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvc25hcHNob3RfZGV0YWlscy5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzIlwKD1NuYXBzaG90RGV0YWlscxIMCgRuYW1lGAEgASgJEigKBHRpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhEKCXNjaG9vbF9pZBgDIAEoCUIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * Describes the message studyo.today.schools.v1.resources.SnapshotDetails.
 * Use `create(SnapshotDetailsSchema)` to create a new message.
 */
export const SnapshotDetailsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_snapshot_details, 0);

